import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import NetworkCreateDialog from 'routes/Network/containers/NetworkCreateDialog';
import PeriodicAuditEdit from './containers/PeriodicAuditEdit';
import PeriodicAuditView from './containers/PeriodicAuditView';
import { PERIODIC_AUDIT_ROUTE, SYSTEM, SYSTEM_CONFIGURATION_ROUTE } from '../../constants';

interface Props {
}

const PerodicAudit: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${PERIODIC_AUDIT_ROUTE}/edit`}>
        <PeriodicAuditEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${PERIODIC_AUDIT_ROUTE}`}>
        <PeriodicAuditView />
      </Route>
      <NetworkCreateDialog />
    </Fragment>
  );
};

export default PerodicAudit;
